import {makeStyles} from "tss-react/mui";
import {Box, CircularProgress, Typography} from "@mui/material";
import {CourseSummaryCard} from "./components/CourseSummaryCard";
import {palette} from "@/constants";
import {Link} from "react-router-dom";
import {useFinishedCourses} from "./hooks";
import {useSSTranslation} from "@/i18n/useSSTranslation";

const useStyles = makeStyles()((theme) => ({
	myCompletedCourses: {
		display: "flex",
		flexDirection: "column",
		gap: "10px",
		padding: "15px",
		border: "1px solid " + palette.grey08,
		borderRadius: "16px",
		background: "#282828"
	},
	centerWrapper: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
		alignItems: "center",
		height: "100%",
		flexDirection: "column"
	}
}));

export const MyFinishedCourses: React.FC = () => {
	const {classes} = useStyles();
	const {t} = useSSTranslation();
	const {courses, isLoading} = useFinishedCourses();

	return (
		<Box className={classes.myCompletedCourses}>
			{isLoading && <div className={classes.centerWrapper}><CircularProgress color="secondary" /></div>}
			{!isLoading && courses.length === 0 && <Typography variant="body1">{t("page_progress_no_courses", "No courses completed")}</Typography>}
			{courses.map((course) =>
				course.isActive !== false ? (
					<Link
						to={`/course/${course.slug}`}
						key={course.id}
						style={{textDecoration: "none", color: "inherit", display: "block"}}
					>
						<CourseSummaryCard course={course} />
					</Link>
				) : (
					<Box key={course.id} sx={{display: "block"}}>
						<CourseSummaryCard course={course} />
					</Box>
				)
			)}
		</Box>
	);
}
